import React from "react";
import PropTypes from "prop-types";
import DatePickerPackage from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { css } from "react-emotion";
import { Button, FlexColumn, LineButton } from "appStyles";

const datePicker = css`
  padding: 0px;
  text-align: center;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  cursor: pointer;
  color: black;
  width: 127px;
  font-size: 15px;
  text-align: left;
  padding-left: 5px;
  border: 0px;
  outline: 0px;

  select::-ms-expand {
    display: block;
  }
  /* Removes the default <select> styling */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  /* Positions background arrow image */
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAA20lEQVQ4T+3SL0tDcRjF8c8V2YrJqHF1VTAIK5rtewGCb2BNWBIcmKy+gYW9ATGJIPblwZLNZBqMyQ9+Vy4/7j/wxj31Oc8XzjlPpuPJOubZA/+faJphDxPMsGnA96P2oahNgUd4xRpjbCugh5jjFJf4yXVlLR/jDR+4wS6BHuAZZxjhu7ivepsTvGMRbeXQoH/ENS7wlTqo+8NBhD7hPh7e4TbCVmVxND32MNoPoGB1Gm0uqwprAoa7c7xEwBU+69pvAwz3ockw4QNqpy2wifO33wNbR1Up7DzDX2zcHRV0yPnBAAAAAElFTkSuQmCC");
  background-repeat: no-repeat;
  background-position: 104px center;
`;

const datePickerWithTime = css`
  padding: 0px;
  text-align: center;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  cursor: pointer;
  color: black;
  width: 200px;
  font-size: 15px;
  text-align: left;
  padding-left: 5px;
  border: 0px;
  outline: 0px;

  select::-ms-expand {
    display: block;
  }
  /* Removes the default <select> styling */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  /* Positions background arrow image */
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAA20lEQVQ4T+3SL0tDcRjF8c8V2YrJqHF1VTAIK5rtewGCb2BNWBIcmKy+gYW9ATGJIPblwZLNZBqMyQ9+Vy4/7j/wxj31Oc8XzjlPpuPJOubZA/+faJphDxPMsGnA96P2oahNgUd4xRpjbCugh5jjFJf4yXVlLR/jDR+4wS6BHuAZZxjhu7ivepsTvGMRbeXQoH/ENS7wlTqo+8NBhD7hPh7e4TbCVmVxND32MNoPoGB1Gm0uqwprAoa7c7xEwBU+69pvAwz3ockw4QNqpy2wifO33wNbR1Up7DzDX2zcHRV0yPnBAAAAAElFTkSuQmCC");
  background-repeat: no-repeat;
  background-position: 175px center;
`;

const container = css`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

const titleStyle = css`
  white-space: nowrap;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 15px;
  line-height: 18px;
`;

const flexColumn = css`
  display: flex;
  flex-direction: column;
  align-content: center;
  position: relative;
  justify-content: center;
  height: 100%;
  width: 100%;
`;

const mobileView = css`
  position: fixed !important;
  z-index: 1300;
  top: 1% !important;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
`;

const DatePicker = (props) => {
  const {
    selected,
    title,
    isExpirationDate,
    datePickerProps = {},
    disabled,
    minDateFalse,
    maxDate,
    isDateChecker,
  } = props;

  const onChange = (e) => {
    props.onChange(e.getTime());
  };
  // console.log("datepicker got date");
  // console.log(selected);
  const nullDate = "1969-12-31T23:59:59.000+0000";
  var nullCheckSelected = selected;
  if (selected === nullDate) {
    // console.log("datepicker got null date");
    nullCheckSelected = null;
  }

  return (
    <div
      className={container}
      style={{
        ...datePickerProps.style,
      }}
    >
      {isExpirationDate && (
        <div
          className={flexColumn}
          style={{ width: "auto", marginRight: "10px" }}
        >
          {title && <span className={titleStyle}>{title}</span>}
          <LineButton
            fontSize="12px"
            fontHeight="14px"
            fd
            onClick={() => props.onChange(null)}
          >
            Never Expire
          </LineButton>
        </div>
      )}
      {isDateChecker && (
        <div style={{ marginRight: "10px" }}>
          {title && <span className={titleStyle}>{title}</span>}
        </div>
      )}
      <DatePickerPackage
        {...datePickerProps}
        className={
          datePickerProps.showTimeSelect ? datePickerWithTime : datePicker
        }
        selected={nullCheckSelected ? new Date(selected) : null}
        placeholderText="Select"
        minDate={minDateFalse ? null : new Date()}
        maxDate={maxDate ? maxDate : null}
        onChange={onChange}
        disabled={disabled}
      />
    </div>
  );
};

DatePicker.propTypes = {
  onChange: PropTypes.func,
};

export default DatePicker;
